import { CommonModule  } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';

// Translator.
import { TranslateService, TranslatePipe, TranslateDirective, TranslateModule } from "@ngx-translate/core";
import translationEN from "../assets/i18n/en.json"
import translationES from "../assets/i18n/es.json"
import translationptBR from "../assets/i18n/pt-BR.json"

// Models.
import { AuthInfo } from './models/authObjects';

// Services.
import { AuthService } from './services/auth.service';

// Material.
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

declare global {
  interface Window {
    __karma__?: any;
  }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  standalone: true,
  imports: [   
    RouterOutlet, 
    CommonModule, 
    MatSidenavModule,
    MatToolbarModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatSelectModule,
    TranslatePipe,
    TranslateModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule
  ]
})
export class AppComponent implements OnInit {
  constructor(
    private authService: AuthService,
    public translate: TranslateService
  ){
    const savedLang = localStorage.getItem('language') || 'en';
    this.translate.addLangs(['en', 'es', 'pt-BR']);
    this.translate.setTranslation('en', translationEN);
    this.translate.setTranslation('es', translationES);
    this.translate.setTranslation('pt-BR', translationptBR);
    this.translate.setDefaultLang(savedLang);
    this.translate.use(savedLang);

    this.authService.loginObs.subscribe(user => {
      this.isUserLoggedIn = !!user;
      this.userInfo = user;
    });
  }
  router = inject(Router);

  userInfo: AuthInfo | null = null;
  isSidebarOpen = false;
  isUserLoggedIn = false;

  ngOnInit(): void {
    this.authService.loginObs.subscribe((user) => {
      this.isUserLoggedIn = !!user;
      this.userInfo = user;
    });

    if (this.authService.isLoggedIn()) {
      this.userInfo = this.authService.loginData;
      this.isUserLoggedIn = true;
    }
  }

  navigateToDashboard() {
    this.router.navigate(['/dashboard']);
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  changeLanguage(lang: string): void {
    this.translate.use(lang);
    localStorage.setItem('language', lang);

    if (!window['__karma__']) {
      window.location.reload();
    }
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }
}